import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutLateRouteStatus } from "./autogen/AutogenLayoutLateRouteStatus";
import { ColorSelectorUtil, SelectedColor } from "@mcleod/common";
import { DuplicateId, DuplicateIdProps } from "../DuplicateId";

const viewCategoryURL = "lme/dispatch/asset/LateRouteStatus?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "late_route_status",
    screenName: "Late Route Status",
    navigateToUrl: viewCategoryURL
};

export class LateRouteStatus extends AutogenLayoutLateRouteStatus {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }

    sourceLateRouteStatusAfterExecution(event: DataSourceExecutionEvent) {
        this.panelColorDisplay.backgroundColor = this.activeRow?.get("late_route_status_color");
    }

    buttonClearColorOnClick() {
        this.syncPlanningColor({});
    }

    async buttonColorPickerOnClick() {
        const result = await ColorSelectorUtil.promptForNumericColor();
        if (result?.hexColor && result?.numericColor) {
            this.syncPlanningColor(result);
        }
    }

    private syncPlanningColor(result: SelectedColor = {}) {
        const { colorName, hexColor, numericColor } = result;
        this.sourceLateRouteStatus.activeRow.set("planning_hex_color", hexColor);
        this.sourceLateRouteStatus.activeRow.set("planning_color", numericColor);
        this.panelColorDisplay.backgroundColor = colorName;
        this.panelColorDisplay.tooltip = hexColor;
    }
}
